import { Box, Flex, Icon, Text, Tooltip } from '@chakra-ui/react';
import { InputField } from './InputField';
import { useField } from 'formik';
import { useRef, useState } from 'react';
import { Check, Edit03, XClose } from '@kula-ai/icons-core';

interface InputInlineEditProps {
  item?: Record<string, unknown>;
  field: any;
  formik?: any;
}

export const InputInlineEdit = ({
  item = {},
  field,
  formik,
}: InputInlineEditProps) => {
  const {
    name,
    textProps = {},
    inlineMode = 'notSwap', //swap
    additionalText,
    toolTipText,
    disabled,
  } = item as any;

  const [isEditing, setEditing] = useState(false);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [_field, meta, helpers] = useField(name);
  const { setValue } = helpers;
  const hasInputValue = Boolean(meta?.value);

  const handleSave = () => {
    const val = inputRef?.current?.value;
    if (val) {
      setValue(val);
      setEditing(false);
    }
  };

  return (
    <Flex alignItems="center" gap="15px">
      <Flex alignItems="center" gap="1em" w="100%">
        <InputField
          item={{ ...item, isEditable: isEditing, inputRef }}
          field={field}
          formik={formik}
        />
        {inlineMode === 'swap' && (
          <Flex gap=".5em" mr="15em">
            <Check
              size="1.5em"
              color="var(--kula-colors-ats-primary)"
              className="kula-icon"
              style={{
                opacity: hasInputValue ? 1 : 0.5,
                cursor: hasInputValue ? 'pointer' : 'not-allowed',
              }}
              onClick={handleSave}
            />
            <XClose
              size="1.5em"
              color="var(--kula-colors-ats-negative)"
              className="kula-icon"
              style={{ cursor: 'pointer' }}
              onClick={() => setEditing(false)}
            />
          </Flex>
        )}
      </Flex>
      {!isEditing && !disabled && (
        <Tooltip variant="default" label={toolTipText}>
          <Box mt="10px">
            <Icon
              as={Edit03}
              cursor="pointer"
              _hover={{
                color: 'ats-primary',
              }}
              onClick={() => setEditing(true)}
            />
          </Box>
        </Tooltip>
      )}
      {additionalText && (
        <Text fontSize="sm" color="ats-text-secondary" {...textProps}>
          {additionalText}
        </Text>
      )}
    </Flex>
  );
};
